import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useDeleteClaimDetail() {
  return useMutation(trpcOptions.app.deleteClaimDetail.mutationOptions())
}
